export const consoleLogger = {
    trace: console.trace,
    debug: console.debug,
    info: console.info,
    warn: console.warn,
    error: console.error
};
const argToString = (arg) => {
    if (arg === null) {
        return "null";
    }
    else if (arg === undefined) {
        return "undefined";
    }
    else if (Array.isArray(arg) || typeof arg === "object") {
        try {
            return JSON.stringify(arg, null, "   ");
        }
        catch (e) {
            return e.toString();
        }
    }
    else {
        return arg.toString();
    }
};
export const createLogger = (glue, loggerClient, level = "debug") => {
    const logger = glue.logger.subLogger("fsbl-service");
    logger.publishLevel(level);
    return {
        loggerClient,
        trace: (...args) => {
            console.trace(...args);
            logger.trace(args.map((arg) => argToString(arg)).join("\n"));
            loggerClient?.verbose(...args);
        },
        debug: (...args) => {
            console.debug(...args);
            logger.debug(args.map((arg) => argToString(arg)).join("\n"));
            loggerClient?.debug(...args);
        },
        info: (...args) => {
            console.info(...args);
            logger.info(args.map((arg) => argToString(arg)).join("\n"));
            loggerClient?.info(...args);
        },
        warn: (...args) => {
            console.warn(...args);
            logger.warn(args.map((arg) => argToString(arg)).join("\n"));
            loggerClient?.warn(...args);
        },
        error: (...args) => {
            console.error(...args);
            if (args?.[1]?.stack) {
                logger.error(`${args[0]}\n${args[1].stack}`);
                loggerClient?.error(args[0], args[1].stack.split("\n"));
            }
            else {
                logger.warn(args.map((arg) => argToString(arg)).join("\n"));
                loggerClient?.warn(...args);
            }
        }
    };
};
